import React, { useState, useEffect, useRef } from 'react';
import DateRangeFilter from '../dateRangeFilter';
import { getListStatusFacturation } from '../../../client/facturation';
import Select from 'react-select'; 

const BillingFilters = ({
  onDateRangeChange = () => {},
  onStatusChange = () => {},
  applyFilters,
  activeFilters = {},
  resetFlag,
  position = "md:right-0 right-auto",
  activeTab = 'Todas'
}) => {

  const [showFilters, setShowFilters] = useState(false);
  
  const [estadoOptions, setEstadoOptions] = useState([]);
  const [selectedEstado, setSelectedEstado] = useState([]);
  const [loadingEstado, setLoadingEstado] = useState(false);

  const [selectedDateRange, setSelectedDateRange] = useState({ 
    startDate: '', 
    endDate: '' 
  });

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '40px',
      maxHeight: '120px',
      overflow: 'auto',
      borderColor: '#D1D5DB',
      '&:hover': { borderColor: '#D1D5DB' },
      boxShadow: state.isFocused ? 'none' : base.boxShadow,
    }),
    menu: (base) => ({
      ...base,
      position: 'absolute',
      zIndex: 9999,
      marginTop: '4px',
      width: '100%',
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
  };

  useEffect(() => {
    if (showFilters && activeTab === 'Todas') {
      loadEstados();
    }
  }, [showFilters, activeTab]);

  useEffect(() => {
    if (activeFilters.emissionDateFrom && activeFilters.emissionDateTo) {
      setSelectedDateRange({
        startDate: activeFilters.emissionDateFrom,
        endDate: activeFilters.emissionDateTo
      });
    } else {
      setSelectedDateRange({ startDate: '', endDate: '' });
    }
    if (activeFilters.statusIds && Array.isArray(activeFilters.statusIds)) {
      const selectedOptions = estadoOptions.filter(option => 
        activeFilters.statusIds.includes(option.value)
      );
      setSelectedEstado(selectedOptions);
    } else {
      setSelectedEstado([]);
    }
  }, [activeFilters, estadoOptions]);

  useEffect(() => {
    setSelectedDateRange({ startDate: '', endDate: '' });  
    setSelectedEstado([]);
  }, [resetFlag]);

  useEffect(() => {
    if (activeFilters.emissionDateFrom && activeFilters.emissionDateTo) {
      setSelectedDateRange({
        startDate: activeFilters.emissionDateFrom,
        endDate: activeFilters.emissionDateTo
      });
    }
    if (activeFilters.statusIds && Array.isArray(activeFilters.statusIds)) {
      const selectedOptions = estadoOptions.filter(option => 
        activeFilters.statusIds.includes(option.value)
      );
      setSelectedEstado(selectedOptions);
    } else {
      setSelectedEstado([]);
    }
  }, [activeFilters, estadoOptions]);

  const loadEstados = async () => {
    if (estadoOptions.length > 0) return; 
    setLoadingEstado(true);
    try {
      const response = await getListStatusFacturation();
      if (response.data && Array.isArray(response.data)) {
        const estadosMapeados = response.data.map(status => ({
          value: status.id, 
          label: status.name 
        }));
        setEstadoOptions(estadosMapeados);
      } else if (response.data && response.data.status) {
        const estadosMapeados = response.data.status.map(status => ({
          value: status.id, 
          label: status.name 
        }));
        setEstadoOptions(estadosMapeados);
      }
    } catch (error) {
      console.error('Error cargando estados de facturación:', error);
    } finally {
      setLoadingEstado(false);
    }
  };

  const toggleFilters = () => setShowFilters(!showFilters);

  const handleDateRangeChange = ({ startDate, endDate }) => {
    setSelectedDateRange({ startDate, endDate });
    onDateRangeChange({ startDate, endDate });
  };

  const handleEstadoChange = (selectedOptions) => {
    setSelectedEstado(selectedOptions || []);
  };

  const handleApplyFilters = () => {
    const filtersToApply = {
      emissionDateFrom: selectedDateRange.startDate,
      emissionDateTo: selectedDateRange.endDate,
      statusIds: null
    };

    if (activeTab === 'Todas') {
      filtersToApply.statusIds = selectedEstado.length > 0 
        ? selectedEstado.map(option => option.value) 
        : null;
    } else {
      filtersToApply.statusIds = null;
    }

    
    applyFilters(filtersToApply);
    setShowFilters(false);
  };

const hasActiveFilters = () => {

  const dateFiltersActive = 
    selectedDateRange.startDate && 
    selectedDateRange.startDate !== '' && 
    selectedDateRange.endDate && 
    selectedDateRange.endDate !== '';
  
  const statusFilterActive = 
    activeTab === 'Todas' && 
    selectedEstado.length > 0;
  
  return dateFiltersActive || statusFilterActive;
};

  return (
    <div className='relative' >
      <button
        onClick={toggleFilters}
        className={`flex items-center justify-center font-itcbook px-2 w-[105px] border-blue-light text-sm border-[1px] h-[40px] rounded-lg ${
          hasActiveFilters() 
            ? 'bg-blue-light text-white' 
            : 'bg-transparent text-[#6B7280]'
        }`}
      >
        Filtrar por
      </button>
      
      {showFilters && (
        <div
          onClick={(e) => e.stopPropagation()}
          className={`md:p-4 p-4 md:px-5 bg-white absolute ${position} top-12 overflow-y-auto max-h-[400px] md:max-h-[450px] rounded-lg w-[266px] sm:w-[372px] z-10 shadow-[0px_1px_3px_0px_#0000004D,0px_4px_8px_3px_#00000026]`}
        >
          <div className='flex flex-col gap-3'>
            <p className='text-base text-blue font-itcbold'>Filtrar por</p>
            <div className='w-full h-[1px] md:my-2 bg-[#D9D9D9]'></div>

            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>
                Fecha de creación:
              </p>
              <DateRangeFilter
                onDateRangeChange={handleDateRangeChange}
                value={selectedDateRange}
              />
            </div>

            {activeTab === 'Todas' && (
              <div className='flex flex-col gap-2'>
                <p className='text-sm md:text-base text-blue font-itcbook'>
                  Estados:
                </p>
                <Select
                  isMulti
                  isLoading={loadingEstado}
                  isDisabled={loadingEstado}
                  options={estadoOptions}
                  value={selectedEstado}
                  onChange={handleEstadoChange}
                  placeholder={loadingEstado ? "Cargando..." : "Seleccione estados"}
                  className="text-sm font-itcbook"
                  noOptionsMessage={() => "No hay opciones disponibles"}
                  styles={selectStyles}
                />
              </div>
            )}

            <div className="flex justify-center w-full pt-6">
              <button
                onClick={handleApplyFilters}
                className="underline text-blue font-itcbold"
              >
                Aplicar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BillingFilters;